import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '../../app/navBar.js';
import { catalogApi } from '../../../api/catalogApi.js';
import './createItemScreen.css';

const CreateItemScreen = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        servingSize: 0,
        servingUnit: 'units',
        calories: 0,
        totalFat: 0,
        saturatedFat: 0,
        transFat: 0,
        cholesterol: 0,
        sodium: 0,
        brand: '',
        description: '',
        totalCarb: 0,
        fiber: 0,
        sugar: 0,
        protein: 0,
        vitamin_a: 0,
        vitamin_c: 0,
        vitamin_d: 0,
        calcium: 0,
        iron: 0,
        potassium: 0,
        caffeine: 0,
        alcohol: 0,
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Name is required.";
        if (!String(formData.servingSize).trim() || isNaN(formData.servingSize)) newErrors.servingSize = "Serving Size must be a number.";
        if (!String(formData.calories).trim() || isNaN(formData.calories)) newErrors.calories = "Calories must be a number.";
        if (!String(formData.totalFat).trim() || isNaN(formData.totalFat)) newErrors.totalFat = "Total Fat must be a number.";
        if (!String(formData.saturatedFat).trim() || isNaN(formData.saturatedFat)) newErrors.saturatedFat = "Saturated Fat must be a number.";
        if (!String(formData.sodium).trim() || isNaN(formData.sodium)) newErrors.sodium = "Sodium must be a number.";
        if (!String(formData.caffeine).trim() || isNaN(formData.caffeine)) newErrors.caffeine = "Caffeine must be a number.";
        if (!String(formData.alcohol).trim() || isNaN(formData.alcohol)) newErrors.alcohol = "Alcohol must be a number.";

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const params = {
            ...formData,
            servingSize: formData.servingSize,
            calories: parseInt(formData.calories, 10),
            totalFat: formData.totalFat,
            saturatedFat: formData.saturatedFat,
            transFat: formData.transFat ? parseInt(formData.transFat, 10) : 0,
            sodium: parseInt(formData.sodium, 10),
            caffeine: parseInt(formData.caffeine, 10),
            alcohol: parseInt(formData.alcohol, 10),
        };

        try {
            const response = await catalogApi.createItem(params);

            if (response.status === true) {
                displayBanner("Success", "green");
            } else {
                displayBanner("Failure", "red");
                console.error("Error creating the item:", response.msg);
            }
        } catch (error) {
            console.error("Error creating the item:", error);
            displayBanner("Failure", "red");
        }
    };

    const displayBanner = (message, type) => {
        const banner = document.createElement("div");
        banner.textContent = message;
        banner.classList.add("banner", type === "green" ? "success" : "failure");

        document.body.appendChild(banner);

        setTimeout(() => {
            banner.style.opacity = "0";
            setTimeout(() => banner.remove(), 500);
        }, 4000);
    };

    return (
        <div>
            <NavBar />
            <div className="form-container">
                <form onSubmit={handleSubmit} className="grid-form">
                    <div className="form-group">
                        <label htmlFor="brand">Brand:</label>
                        <input id="brand" name="brand" value={formData.brand} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="name">Name:</label>
                        <input id="name" name="name" value={formData.name} onChange={handleChange} />
                        {errors.name && <span className="error">{errors.name}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="servingSize">Serving Size:</label>
                        <input id="servingSize" name="servingSize" value={formData.servingSize} onChange={handleChange} />
                        {errors.servingSize && <span className="error">{errors.servingSize}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="servingUnit">Serving Unit:</label>
                        <select id="servingUnit" name="servingUnit" value={formData.servingUnit} onChange={handleChange}>
                            <option value="units">Units</option>
                            <option value="fl oz">Fl oz</option>
                            <option value="cups">Cups</option>
                            <option value="grams">Grams</option>
                            <option value="tbsp">Tbsp</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="calories">Calories:</label>
                        <input id="calories" name="calories" value={formData.calories} onChange={handleChange} />
                        {errors.calories && <span className="error">{errors.calories}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="totalFat">Total Fat (g):</label>
                        <input id="totalFat" name="totalFat" value={formData.totalFat} onChange={handleChange} />
                        {errors.totalFat && <span className="error">{errors.totalFat}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="saturatedFat">Saturated Fat (g):</label>
                        <input id="saturatedFat" name="saturatedFat" value={formData.saturatedFat} onChange={handleChange} />
                        {errors.saturatedFat && <span className="error">{errors.saturatedFat}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="transFat">Trans Fat (g):</label>
                        <input id="transFat" name="transFat" value={formData.transFat} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="cholesterol">Cholesterol (mg):</label>
                        <input id="cholesterol" name="cholesterol" value={formData.cholesterol} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="sodium">Sodium (mg):</label>
                        <input id="sodium" name="sodium" value={formData.sodium} onChange={handleChange} />
                        {errors.sodium && <span className="error">{errors.sodium}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="totalCarb">Total Carb (g):</label>
                        <input id="totalCarb" name="totalCarb" value={formData.totalCarb} onChange={handleChange} />
                        {errors.totalCarb && <span className="error">{errors.totalCarb}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="fiber">Fiber (g):</label>
                        <input id="fiber" name="fiber" value={formData.fiber} onChange={handleChange} />
                        {errors.fiber && <span className="error">{errors.fiber}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="sugar">Sugar (g):</label>
                        <input id="sugar" name="sugar" value={formData.sugar} onChange={handleChange} />
                        {errors.sugar && <span className="error">{errors.sugar}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="protein">Protein (g):</label>
                        <input id="protein" name="protein" value={formData.protein} onChange={handleChange} />
                        {errors.protein && <span className="error">{errors.protein}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="vitamin_a">Vitamin A (mg):</label>
                        <input id="vitamin_a" name="vitamin_a" value={formData.vitamin_a} onChange={handleChange} />
                        {errors.vitamin_a && <span className="error">{errors.vitamin_a}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="vitamin_c">Vitamin C (mg):</label>
                        <input id="vitamin_c" name="vitamin_c" value={formData.vitamin_c} onChange={handleChange} />
                        {errors.vitamin_c && <span className="error">{errors.vitamin_c}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="vitamin_d">Vitamin D (mg):</label>
                        <input id="vitamin_d" name="vitamin_d" value={formData.vitamin_d} onChange={handleChange} />
                        {errors.vitamin_d && <span className="error">{errors.vitamin_d}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="calcium">Calcium (mg):</label>
                        <input id="calcium" name="calcium" value={formData.calcium} onChange={handleChange} />
                        {errors.calcium && <span className="error">{errors.calcium}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="iron">Iron (mg):</label>
                        <input id="iron" name="iron" value={formData.iron} onChange={handleChange} />
                        {errors.iron && <span className="error">{errors.iron}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="potassium">Potassium (mg):</label>
                        <input id="potassium" name="potassium" value={formData.potassium} onChange={handleChange} />
                        {errors.potassium && <span className="error">{errors.potassium}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="caffeine">Caffeine (mg):</label>
                        <input id="caffeine" name="caffeine" value={formData.caffeine} onChange={handleChange} />
                        {errors.caffeine && <span className="error">{errors.caffeine}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="alcohol">Alcohol (g):</label>
                        <input id="alcohol" name="alcohol" value={formData.alcohol} onChange={handleChange} />
                        {errors.alcohol && <span className="error">{errors.alcohol}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">Description (Optional):</label>
                        <textarea id="description" name="description" value={formData.description} onChange={handleChange} />
                    </div>

                    <button type="submit" className="submit-btn">Submit</button>
                </form>
            </div>
        </div>
    );
}

export { CreateItemScreen };
